"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.create.title': 'Utwórz Poradnik',
    'tutorial.create.button': 'Utwórz Poradnik',
};
